import Vue from "vue";
import VueRouter from "vue-router";
import { changeLang } from "../locals/index";
import Layout from "./../layout/index.vue";

Vue.use(VueRouter);

const routes = [
  // 在这里定义你的路由配置
  // {
  //   path: "/week2025/home/:lang",
  //   name: "ArrNoRepeat",
  //   component: () => import("@/views/dashboardBox.vue"),
  // },
  {
    path: "/week2025",
    name: "Layout",
    component: Layout,
    children: [
      {
        path: "home/:lang",
        name: "ArrNoRepeat",
        component:  () => import("@/views/dashboardBox.vue"),
      },
      {
        path: "sponsor/:lang",
        name: "Partners",
        component: () => import("@/views/partner/index.vue"),
      },
      {
        path: "agenda/:lang",
        name: "Agenda",
        component: () => import("@/views/agent/index.vue"),
      },
      {
        path: "speakers/:lang",
        name: "Speakers",
        component: () => import("@/views/Speakers"),
      },
      {
        path: "live/:lang",
        name: "Live",
        component: () => import("@/views/live/index.vue"),
      },
      {
        path: "live_review/:lang",
        name: "LiveReview",
        component: () => import("@/views/liveReview/index.vue"),
      },
      {
        path: "openDay/:lang",
        name: "SideEvent",
        component: () => import("@/views/sideEvent/index.vue"),
      },
    ],
  },
];

const router = new VueRouter({
  routes,
  mode: "history",
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      // 滚动到之前的位置
      return savedPosition;
    } else {
      // 总是滚动到页面顶部
      return { x: 0, y: 0 };
    }
  },
});


const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') throw err;
  });
};
// 设置语言环境
router.beforeEach(async (to, from, next) => {
  try {
    const lang = to.params.lang;
    if (lang !== "zh" && lang !== "en") {
      return next("/week2025/home/zh");
    }
    //设置语言环境
    await changeLang(lang);
    next();
  } catch (error) {
    //切换失败，设置为中文
    const path = to.path.replace(/en/, "zh");
    next(path);
  }
});


export default router;
